
import SegmentedButton from "./SegmentedButton.vue"

export default {
  components: {
    SegmentedButton
  },
  provide() {
    return {
      segmentedGroup: this
    }
  },
  model: {
    prop: "selectedValue",
    event: "checked"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    selectedValue: {
      type: [String, Object, Boolean],
      default: ""
    },
    options: {
      type: Array,
      default: null
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hasError: {
      type: Boolean,
      default: false
    },
    noGap: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ""
    }
  },
  computed: {
    feedbackId() {
      return `${this.name}-feedback`
    },
    formClasses() {
      return {
        "no-gap": this.noGap,
        "no-gap__error": this.noGap && this.hasError,
        "segmented-group__form--wrap": this.wrap
      }
    },
    groupClasses() {
      return { "segmented-group__error": this.hasError }
    }
  },
  methods: {
    checked(checked) {
      this.$emit("checked", checked)
    }
  }
}
